import React from 'react';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const ScoreLevel = ({ score, level, englishscore }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-score relative justify-center flex lg:flex-col items-center text-center lg:gap-2 sm:gap-2 lg:px-5 lg:py-1 sm:px-2 shadow-lg lg:border-8 sm:border-4 border-solid">
      <div className="level-container flex items-center text-center lg:gap-2 sm:gap-1 px-3 py-1 lg:rounded-lg sm:rounded-md sm:mt-1">
        <p className="font-bold  italic lg:text-xl sm:text-xs">Level :</p>
        <p className="font-bold  italic lg:text-xl sm:text-xs">{level}</p>
      </div>
      <div className="score-container flex items-center text-center lg:gap-4 sm:gap-1 py-1 lg:rounded-lg">
        <div>
          <p className="font-bold  italic lg:text-xl sm:text-xs">
            {t("game_score")}
          </p>
          <p className="font-bold  italic lg:text-xl sm:text-xs">{score}</p>
        </div>
        <div>
          <p className="font-bold  italic lg:text-xl sm:text-xs">
            {t("english_score")}
          </p>
          <p className="font-bold  italic lg:text-xl sm:text-xs">
            {englishscore}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScoreLevel;
